

// /**
//  * adapted from http://stemkoski.github.io/Three.js/Sprite-Text-Labels.html
//  */

import * as THREE from "../libs/three.js/build/three.module.js";

export class TextSprite extends THREE.Object3D {

	constructor(text) {
		super();

		let texture = new THREE.Texture();
		texture.minFilter = THREE.LinearFilter;
		texture.magFilter = THREE.LinearFilter;
		let spriteMaterial = new THREE.SpriteMaterial({
			map: texture,
			depthTest: false,
			depthWrite: false
		});

		this.texture = texture;

		this.material = spriteMaterial;
		//this.material = getRawMaterial(texture);
		this.sprite = new THREE.Sprite(this.material);
		this.add(this.sprite);

		this.fontface = 'Arial';
		this.fontsize = 28;
		this.borderColor = { r: 0, g: 0, b: 0, a: 1.0 };
		this.backgroundColor = { r: 255, g: 255, b: 255, a: 1.0 };
		this.textColor = { r: 255, g: 255, b: 255, a: 1.0 };
		this.text = '';

		this.setText(text);
	}

	setText(text) {
		if (this.text !== text) {
			this.text = text;

			this.update();
		}
	}

	setTextColor(color) {
		this.textColor = color;

		this.update();
	}

	setBorderColor(color) {
		this.borderColor = color;

		this.update();
	}

	setBackgroundColor(color) {
		this.backgroundColor = color;

		this.update();
	}

	update() {
		let canvas = document.createElement('canvas');
		let context = canvas.getContext('2d');
		context.font = 'Bold ' + this.fontsize + 'px ' + this.fontface;

		const borderThickness = parseInt(this.fontsize / 4)
		// get size data (height depends only on font size)
		let metrics = context.measureText(this.text);
		let textWidth = metrics.width;
		let margin = 5;
		let spriteWidth = 2 * margin + textWidth + 2 * borderThickness;
		let spriteHeight = this.fontsize * 1.4 + 2 * borderThickness;

		context.canvas.width = spriteWidth;
		context.canvas.height = spriteHeight;
		context.font = 'Bold ' + this.fontsize + 'px ' + this.fontface;

		// background color
		context.fillStyle = 'rgba(' + this.backgroundColor.r + ',' + this.backgroundColor.g + ',' +
			this.backgroundColor.b + ',' + this.backgroundColor.a + ')';
		// border color
		context.strokeStyle = 'rgba(' + this.borderColor.r + ',' + this.borderColor.g + ',' +
			this.borderColor.b + ',' + this.borderColor.a + ')';

		context.lineWidth = borderThickness;
		this.roundRect(context, borderThickness / 2, borderThickness / 2,
			textWidth + borderThickness + 2 * margin, this.fontsize * 1.4 + borderThickness, 6);

		// text color
		context.strokeStyle = 'rgba(0, 0, 0, 1.0)';
		context.strokeText(this.text, borderThickness + margin, this.fontsize + borderThickness);

		context.fillStyle = 'rgba(' + this.textColor.r + ',' + this.textColor.g + ',' +
			this.textColor.b + ',' + this.textColor.a + ')';
		context.fillText(this.text, borderThickness + margin, this.fontsize + borderThickness);

		let texture = new THREE.Texture(canvas);
		texture.minFilter = THREE.LinearFilter;
		texture.magFilter = THREE.LinearFilter;
		texture.needsUpdate = true;

		// 重构178 【必须】释放旧纹理，避免内存泄漏
		if (this.sprite.material.map) {
			this.sprite.material.map.dispose();
		}
		this.sprite.material.map = texture;
		this.texture = texture;

		// 【必须】标记材质需要更新，否则纹理不生效
		this.sprite.material.needsUpdate = true;

		this.sprite.scale.set(spriteWidth * 0.01, spriteHeight * 0.01, 1.0);
	}

	roundRect(ctx, x, y, w, h, r) {
		ctx.beginPath();
		ctx.moveTo(x + r, y);
		ctx.lineTo(x + w - r, y);
		ctx.quadraticCurveTo(x + w, y, x + w, y + r);
		ctx.lineTo(x + w, y + h - r);
		ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
		ctx.lineTo(x + r, y + h);
		ctx.quadraticCurveTo(x, y + h, x, y + h - r);
		ctx.lineTo(x, y + r);
		ctx.quadraticCurveTo(x, y, x + r, y);
		ctx.closePath();
		ctx.fill();
		ctx.stroke();
	}
	copy(value, recursive) {
		// 重构178【必须】调用父类 copy 方法，继承 Object3D 基础属性复制逻辑
		super.copy(value, recursive);

		this.text = value.text;
		let texture = new THREE.Texture();
		texture.minFilter = value.texture.minFilter;
		texture.magFilter = value.texture.magFilter;
		let spriteMaterial = new THREE.SpriteMaterial({
			map: texture,
			depthTest: false,
			depthWrite: false
		});
		spriteMaterial.map = value.material.map;
		spriteMaterial.depthTest = value.material.depthTest;
		spriteMaterial.depthWrite = value.material.depthWrite;

		this.texture = texture;

		this.material = spriteMaterial;
		this.sprite = new THREE.Sprite(this.material);
		this.remove(this.sprite);
		this.add(this.sprite);

		this.fontface = value.fontface;
		this.fontsize = value.fontsize;
		this.borderColor = value.borderColor;
		this.backgroundColor = value.backgroundColor;
		this.textColor = value.textColor;
		this.text = value.text;
		this.visible = value.visible;
		// return new this.constructor().copy( value, recursive );

	}
	clone() {
		var obj = new this.constructor();
		obj.copy(this, true);
		return obj;
	}
}


